import { Insurance as MyProfileInsurance } from 'store/profile/types';
import * as constants from './constants';

export const mapArrayToReqDto = <T>(values: T[]): string | null => {
  if (values && values.length > 0) return values.join(',');
  return null;
};

export const mapArrayToReqDtoByKey = <T extends {}>(values: T[], key: keyof T): string | null => {
  if (values && values.length > 0) return values.map(v => v[key]).join(',');
  return null;
};

// Map to selectHealthNetworkID:DX7897098, cernerHealthPlanId:7987987
export const mapInsurancesToReqDto = (insurances: MyProfileInsurance[]) => {
  const result: string[] = [];
  insurances.forEach((ins: MyProfileInsurance) => {
    switch (ins.source) {
      case constants.INSURANCE_SOURCE_SELECT_HEALTH: {
        result.push(`selectHealthNetworkId:${ins.networkId}`);
        break;
      }
      case constants.INSURANCE_SOURCE_MILLENNIUM: {
        if (ins.planId) result.push(`cernerHealthPlanId:${ins.planId}`);
        else result.push(`cernerHealthPlanCode:${ins.planCode}`);
        break;
      }
      default:
        result.push(`planId:${ins.planId}`);
    }
  });
  return mapArrayToReqDto(result);
};

export const mapInsuranceIdsToReqDto = (insurances: MyProfileInsurance[]) => {
  const result: string[] = [];
  insurances.forEach((ins: MyProfileInsurance) => {
    switch (ins.source) {
      case constants.INSURANCE_SOURCE_SELECT_HEALTH: {
        result.push(`${ins.networkId}`);
        break;
      }
      case constants.INSURANCE_SOURCE_MILLENNIUM: {
        if (ins.planId) result.push(`${ins.planId}`);
        else result.push(`${ins.planCode}`);
        break;
      }
      default:
        result.push(`${ins.planId}`);
    }
  });
  return result;
};
